import * as requestUrl from "./request";

const noAuthUrls: string[] = [
  requestUrl.FT_USERS_CREATE,
  requestUrl.FT_CLIENT_CONFIG,
  requestUrl.FT_PAYMENT_CENTER_CONFIG,
  requestUrl.FT_ACCOUNT_ATTACH,
];

export default noAuthUrls;
